import React from "react";
import { useNavigate } from "react-router-dom";

export function BackButton() {

    const navigate = useNavigate();

    const handleBackButtonClicked = () => {
        navigate(-1);
    };

    return (
        <div className={"back_button"}>
            <button className={"back_button__button"} type="button" onClick={handleBackButtonClicked}>戻る</button>
        </div>
    );
}
